module.exports = __webpack_public_path__ + "static/media/Bzenec.31fc756c.md";